(() => {
  'use strict';
  if (customElements.get('jb-ring-size-experience')) return;
  customElements.define('jb-ring-size-experience', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.guides = this.querySelector('[data-jb-size-guides]');
      this.digital = this.querySelector('[data-jb-size-digital]');
      this.sizer = this.querySelector('jb-ring-sizer');
      this.querySelector('[data-jb-digital-start]')?.addEventListener('click', () => {
        this.guides.hidden = true;
        this.digital.hidden = false;
        this.sizer?.dispatchEvent(new Event('jb:ring-sizer-start'));
        this.sizer?.querySelector('h3')?.focus({ preventScroll: true });
        this.closest('dialog')?.scrollTo({ top: 0, behavior: 'instant' });
      }, options);
      this.querySelector('[data-jb-size-guides-back]')?.addEventListener('click', () => this.showGuides(true), options);
      this.closest('dialog')?.addEventListener('close', () => this.showGuides(false), options);
      this.closest('jb-size-guide')?.querySelector('.cus_sz_chrt_jsb__btn')?.addEventListener('click', () => this.showGuides(false), options);
    }
    showGuides(focus) {
      this.sizer?.dispatchEvent(new Event('jb:ring-sizer-reset'));
      this.digital.hidden = true;
      this.guides.hidden = false;
      const dialog = this.closest('dialog');
      if (focus) {
        const launch = this.querySelector('[data-jb-digital-start]');
        launch?.focus({ preventScroll: true });
        if (!dialog) launch?.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      }
      dialog?.scrollTo({ top: 0, behavior: 'instant' });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
})();
